import React from 'react';
import PropTypes from 'prop-types';
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from 'perfect-scrollbar';
import { NavLink } from 'react-router-dom';
import cx from 'classnames';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Hidden from '@material-ui/core/Hidden';
import Collapse from '@material-ui/core/Collapse';
import { Redirect } from 'react-router';
import Footer from 'components/Footer/Footer.jsx';

import { ExitToApp } from '@material-ui/icons';

// core components

import sidebarStyle from 'assets/jss/material-dashboard-pro-react/components/sidebarStyle.jsx';

import avatar from 'assets/img/faces/avatar1.jpg';

import { Logout, GetUserKey } from 'helpers/UserHelper';
import { Button } from '@material-ui/core';

import sideBarImg from 'assets/img/sidebars/1.jpg';

var ps;

// We've created this component so we can have a ref to the wrapper of the links that appears in our sidebar.
// This was necessary so that we could initialize PerfectScrollbar on the links.
// There might be something with the Hidden component from material-ui, and we didn't have access to
// the links, and couldn't initialize the plugin.
class SidebarWrapper extends React.Component {
	state = {
		logoutClicked: false
	};

	componentDidMount() {
		if (navigator.platform.indexOf('Win') > -1) {
			ps = new PerfectScrollbar(this.refs.sidebarWrapper, {
				suppressScrollX: true,
				suppressScrollY: false
			});
		}
	}

	componentWillUnmount() {
		if (navigator.platform.indexOf('Win') > -1) {
			ps.destroy();
		}
	}

	handleLogout = () => {
		Logout();
		this.setState({ logoutClicked: true });
	};

	render() {
		if (this.state.logoutClicked) {
			return <Redirect to="/app/portal/login" />;
		}
		const { className, user, links } = this.props;

		var logoutRender = function()
		{
			if(localStorage.getItem('userType') == '')
				return "none"
			else
			 return ""
		}
		return (
			<React.Fragment>
				<div className={className} ref="sidebarWrapper">
					{user}
					{links}

					<Footer fluid />
				</div>
				<div
					style={{
						width: '80%',
						margin: 'auto',
						borderTop: '1px solid #f5f5f530',
						zIndex: '500'
					}}
				/>
				<div
					style={{
						width: '80%',
						margin: 'auto'
					}}
				>
				
					<Button
						onClick={this.handleLogout}
						style={{
							zIndex: '500',
							fontWeight: '300',
							color: 'white',
							textTransform: 'none',
							display : logoutRender()
						}}
						className="signOutButton"
					>
						<ExitToApp style={{ fontWeight: '300', marginRight: '15px' }} />
						Sign Out 
					</Button>
				</div>
			</React.Fragment>
		);
	}
}

class Sidebar extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			openAvatar: true,
			openComponents: this.activeRoute('/components'),
			openProfile: this.activeRoute('/profile'),
			openClients: this.activeRoute('/app/clients'),
			openQuotes: this.activeRoute('/quotes'),
			openFna: this.activeRoute('/fna'),
			openForms: this.activeRoute('/forms'),
			openTables: this.activeRoute('/tables'),
			openMaps: this.activeRoute('/maps'),
			openPages: this.activeRoute('-page'),
			openBrokers: this.activeRoute('/brokers'),
			openAssistants: this.activeRoute('/assistants'),
			miniActive: false,
			userType: '',
			name: '',
			surname: ''
		};
		this.activeRoute.bind(this);
	}

	componentDidMount() {
		this.setState({
			userType: GetUserKey('userType'),
			name: GetUserKey('name'),
			surname: GetUserKey('surname')
		});
	}
	// verifies if routeName is the one active (in browser input)
	activeRoute(routeName) {
		return this.props.location.pathname.indexOf(routeName) > -1 ? true : false;
	}

	activeRouteAlt(prop) {
		let mainRoute =
			this.props.location.pathname.indexOf(prop.path) > -1 ? true : false;

		if (!mainRoute && prop.alternate) {
			return this.props.location.pathname.indexOf(prop.alternate) > -1
				? true
				: false;
		}

		return mainRoute;
	}

	openCollapse = collapse => {
		var st = {};
		st[collapse] = !this.state[collapse];
		this.setState(st);
		ps.update();
	};
	render() {
		const { classes, color, routes, bgColor, rtlActive } = this.props;
		const image = sideBarImg;

		let userRoutes = routes.slice();
		userRoutes = userRoutes.filter(r =>
			r.userTypes.includes(this.state.userType)
		);

		const itemText =
			classes.itemText +
			' ' +
			cx({
				[classes.itemTextMini]: this.props.miniActive && this.state.miniActive,
				[classes.itemTextMiniRTL]:
					rtlActive && this.props.miniActive && this.state.miniActive,
				[classes.itemTextRTL]: rtlActive
			});
		const collapseItemText =
			classes.collapseItemText +
			' ' +
			cx({
				[classes.collapseItemTextMini]:
					this.props.miniActive && this.state.miniActive,
				[classes.collapseItemTextMiniRTL]:
					rtlActive && this.props.miniActive && this.state.miniActive,
				[classes.collapseItemTextRTL]: rtlActive
			});
		const userWrapperClass =
			classes.user +
			' ' +
			cx({
				[classes.whiteAfter]: bgColor === 'white'
			});
		const caret =
			classes.caret +
			' ' +
			cx({
				[classes.caretRTL]: rtlActive
			});
		const photo =
			classes.photo +
			' ' +
			cx({
				[classes.photoRTL]: rtlActive
			});
		var user = (
			<div className={userWrapperClass}>
				{this.state.userType !== '1' ? (
					<div className={photo}>
						<img
							src={GetUserKey('avatar') ? GetUserKey('avatar') : avatar}
							className={classes.avatarImg}
							alt="..."
							style={{
								width: '34px',
								height: '34px'
							}}
						/>
					</div>
				) : (
					''
				)}
				<List className={classes.list}>
					<ListItem className={classes.item + ' ' + classes.userItem}>
						<NavLink
							to={'#'}
							className={classes.itemLink + ' ' + classes.userCollapseButton}
							onClick={e => {
								e.preventDefault();
								this.openCollapse('openAvatar');
							}}
						>
							<ListItemText
								primary={this.state.name + ' ' + this.state.surname}
								secondary={
									<b
										className={
											caret +
											' ' +
											classes.userCaret +
											' ' +
											(this.state.openAvatar ? classes.caretActive : '')
										}
									/>
								}
								disableTypography={true}
								className={itemText + ' ' + classes.userItemText}
							/>
						</NavLink>
						{this.state.userType !== '1' ? (
							<Collapse
								in={this.state.openAvatar}
								unmountOnExit
								className="mpContainer"
							>
								<List className={classes.list + ' ' + classes.collapseList}>
									{userRoutes.length > 0
										? userRoutes
												.filter(u => u.name === 'Profile')[0]
												.views.filter(v =>
													v.userTypes.includes(this.state.userType)
												)
												.map((prop, key) => {
													if (!prop.hidden) {
														return (
															<ListItem
																className={classes.collapseItem}
																key={key}
															>
																<NavLink
																	to={prop.path}
																	style={{ marginTop: '25px' }}
																	className={
																		classes.itemLink +
																		cx({
																			[' ' +
																			classes[color]]: this.activeRouteAlt(prop)
																		}) +
																		' ' +
																		classes.userCollapseLinks
																	}
																>
																	<ListItemText
																		primary={prop.name}
																		disableTypography={true}
																		className={collapseItemText}
																	/>
																</NavLink>
															</ListItem>
														);
													} else {
														return null;
													}
												})
										: null}
								</List>
							</Collapse>
						) : (
							''
						)}
					</ListItem>
				</List>
			</div>
		);
		var links = (
			<List className={classes.list}>
				{userRoutes.length > 0 ? (
					userRoutes
						.filter(u => u.name !== 'Profile')
						.map((prop, key) => {
							if (prop.redirect || prop.hidden) {
								return null;
							}
							if (prop.collapse) {
								const navLinkClasses =
									classes.itemLink +
									' ' +
									cx({
										[' ' + classes.collapseActive]: this.activeRoute(prop.path)
									});
								const itemText =
									classes.itemText +
									' ' +
									cx({
										[classes.itemTextMini]:
											this.props.miniActive && this.state.miniActive,
										[classes.itemTextMiniRTL]:
											rtlActive &&
											this.props.miniActive &&
											this.state.miniActive,
										[classes.itemTextRTL]: rtlActive
									});
								const collapseItemText =
									classes.collapseItemText +
									' ' +
									cx({
										[classes.collapseItemTextMini]:
											this.props.miniActive && this.state.miniActive,
										[classes.collapseItemTextMiniRTL]:
											rtlActive &&
											this.props.miniActive &&
											this.state.miniActive,
										[classes.collapseItemTextRTL]: rtlActive
									});
								const itemIcon =
									classes.itemIcon +
									' ' +
									cx({
										[classes.itemIconRTL]: rtlActive
									});
								const caret =
									classes.caret +
									' ' +
									cx({
										[classes.caretRTL]: rtlActive
									});
								return (
									<ListItem key={key} className={classes.item}>
										<NavLink
											to={'#'}
											className={navLinkClasses}
											onClick={e => {
												e.preventDefault();
												this.openCollapse(prop.state);
											}}
										>
											<ListItemIcon className={itemIcon}>
												<prop.icon />
											</ListItemIcon>
											<ListItemText
												primary={prop.name}
												secondary={
													<b
														className={
															caret +
															' ' +
															(this.state[prop.state]
																? classes.caretActive
																: '')
														}
													/>
												}
												disableTypography={true}
												className={itemText}
											/>
										</NavLink>
										<Collapse in={this.state[prop.state]} unmountOnExit>
											<List
												className={classes.list + ' ' + classes.collapseList}
											>
												{(
													prop.views.length > 0 &&
													prop.views.filter(v =>
														v.userTypes.includes(this.state.userType)
													)
												).map((prop, key) => {
													if (prop.redirect || prop.hidden) {
														return null;
													}
													const navLinkClasses =
														classes.collapseItemLink +
														' ' +
														cx({
															[' ' + classes[color]]: this.activeRouteAlt(prop)
														});
													const collapseItemMini =
														classes.collapseItemMini +
														' ' +
														cx({
															[classes.collapseItemMiniRTL]: rtlActive
														});
													return (
														<ListItem
															key={key}
															className={classes.collapseItem}
														>
															<NavLink
																to={prop.path}
																className={navLinkClasses}
															>
																<span className={collapseItemMini}>
																	{prop.mini}
																</span>
																<ListItemText
																	primary={prop.name}
																	disableTypography={true}
																	className={collapseItemText}
																/>
															</NavLink>
														</ListItem>
													);
												})}
											</List>
										</Collapse>
									</ListItem>
								);
							}
							const navLinkClasses =
								classes.itemLink +
								' ' +
								cx({
									[' ' + classes[color]]: this.activeRoute(prop.path)
								});
							const itemText =
								classes.itemText +
								' ' +
								cx({
									[classes.itemTextMini]:
										this.props.miniActive && this.state.miniActive,
									[classes.itemTextMiniRTL]:
										rtlActive && this.props.miniActive && this.state.miniActive,
									[classes.itemTextRTL]: rtlActive
								});
							const itemIcon =
								classes.itemIcon +
								' ' +
								cx({
									[classes.itemIconRTL]: rtlActive
								});
							return (
								<ListItem key={key} className={classes.item}>
									<NavLink to={prop.path} className={navLinkClasses}>
										<ListItemIcon className={itemIcon}>
											<prop.icon />
										</ListItemIcon>
										<ListItemText
											primary={prop.name}
											disableTypography={true}
											className={itemText}
										/>
									</NavLink>
								</ListItem>
							);
						})
				) : (
					<div />
				)}
			</List>
		);

		const drawerPaper =
			classes.drawerPaper +
			' ' +
			cx({
				[classes.drawerPaperMini]:
					this.props.miniActive && this.state.miniActive,
				[classes.drawerPaperRTL]: rtlActive
			});
		const sidebarWrapper =
			classes.sidebarWrapper +
			' ' +
			cx({
				[classes.drawerPaperMini]:
					this.props.miniActive && this.state.miniActive,
				[classes.sidebarWrapperWithPerfectScrollbar]:
					navigator.platform.indexOf('Win') > -1
			});
		return (
			<div ref="mainPanel">
				<Hidden mdUp>
					<Drawer
						variant="temporary"
						anchor={rtlActive ? 'left' : 'right'}
						open={this.props.open}
						classes={{
							paper: drawerPaper + ' ' + classes[bgColor + 'Background']
						}}
						onClose={this.props.handleDrawerToggle}
						ModalProps={{
							keepMounted: true // Better open performance on mobile.
						}}
					>
						<SidebarWrapper
							className={sidebarWrapper}
							user={user}
							links={links}
						/>
						{image !== undefined ? (
							<div
								className={classes.background}
								style={{ backgroundImage: 'url(' + image + ')' }}
							/>
						) : null}
					</Drawer>
				</Hidden>
				<Hidden smDown>
					<Drawer
						onMouseOver={() => this.setState({ miniActive: false })}
						onMouseOut={() => this.setState({ miniActive: true })}
						anchor={rtlActive ? 'right' : 'left'}
						variant="permanent"
						open
						classes={{
							paper: drawerPaper + ' ' + classes[bgColor + 'Background']
						}}
					>
						<SidebarWrapper
							className={sidebarWrapper}
							user={user}
							links={links}
						/>
						{image !== undefined ? (
							<div
								className={classes.background}
								style={{ backgroundImage: 'url(' + image + ')' }}
							/>
						) : null}
					</Drawer>
				</Hidden>
			</div>
		);
	}
}

Sidebar.defaultProps = {
	bgColor: 'blue'
};

Sidebar.propTypes = {
	classes: PropTypes.object.isRequired,
	bgColor: PropTypes.oneOf(['white', 'black', 'blue', 'purple']),
	rtlActive: PropTypes.bool,
	color: PropTypes.oneOf([
		'white',
		'red',
		'orange',
		'green',
		'blue',
		'purple',
		'deepPurple',
		'rose'
	]),
	logo: PropTypes.string,
	logoText: PropTypes.string,
	image: PropTypes.string,
	routes: PropTypes.arrayOf(PropTypes.object)
};

export default withStyles(sidebarStyle)(Sidebar);



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.jsx